import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { useGamesData } from '../Components/Games/hooks/useGameData';
import { useGameFilters } from '../Components/Games/hooks/useGameFilters';
import { SearchAndFilters } from '../Components/Games/components/SearchAndFilters';
import GamesTableComponent from '../Components/Games/GamesTableComponent';
import GameDetailsDrawer from '../Components/Details/GameDetailsDrawer';
import GameDiagnostics from '../Components/Games/components/GameDiagnostics';
import '../Styles/Pages/GamesPage.css';

const GamesPage = () => {
  const { gamesList, gtpGamesData, loading } = useGamesData();
  const { filters, filterOptions, filteredGames } = useGameFilters(gamesList);

  const [selectedGame, setSelectedGame] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [matchedGameData, setMatchedGameData] = useState(null);
  const [gameUpload, setGameUpload] = useState(false);
  const [showDiagnostics, setShowDiagnostics] = useState(false);

  const handleGameClick = (game) => {
    setSelectedGame(game);

    const matchedDetails = gtpGamesData.find((gtpGame) =>
      gtpGame.gameVariants?.some(
        (variant) =>
          variant.moduleId === game.moduleId && variant.clientId === game.clientId
      )
    );

    if (matchedDetails) {
      const exactGameVariant = matchedDetails.gameVariants.find(
        (variant) => variant.moduleId === game.moduleId && variant.clientId === game.clientId
      );

      if (exactGameVariant) {
        const exactPayoutVariant = findExactPayoutVariant(matchedDetails, game, exactGameVariant);

        if (exactPayoutVariant) {
          setMatchedGameData({
            ...matchedDetails,
            mathModel: exactPayoutVariant.mathModel?.payoutPercentage || 'N/A',
            gameName: matchedDetails.displayTitle,
            payoutVariantName: exactPayoutVariant.payoutVariantName,
            launchCode: exactGameVariant.launchCode,
          });
        }
      }
    }

    setDrawerOpen(true);
  };

  const findExactPayoutVariant = (matchedDetails, game, exactGameVariant) => {
    let payoutVariant = matchedDetails.payoutVariants.find(
      (variant) =>
        variant.moduleId === game.moduleId &&
        variant.payoutVariantName === game.launchID
    );

    if (!payoutVariant) {
      payoutVariant = matchedDetails.payoutVariants.find(
        (variant) =>
          variant.moduleId === game.moduleId &&
          variant.id === exactGameVariant.payoutVariantId
      );
    }

    return payoutVariant;
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedGame(null);
    setMatchedGameData(null);
  };

  const handleFileUpload = (acceptedFiles) => {
    console.log('Files uploaded:', acceptedFiles);
    setGameUpload(false);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleFileUpload,
  });

  const toggleDiagnostics = () => {
    setShowDiagnostics(!showDiagnostics);
  };

  return (
    <div className="games-page">
      <div className="header-controls">
        <SearchAndFilters
          filters={filters}
          filterOptions={filterOptions}
        />

        <button
          className="toggle-diagnostics-button"
          onClick={toggleDiagnostics}
        >
          {showDiagnostics ? 'Hide Diagnostics' : 'Show Diagnostics'}
        </button>
      </div>

      {showDiagnostics && <GameDiagnostics gamesList={gamesList} />}

      {gameUpload && (
        <section {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <p>Drop the MGL list here to upload</p>
        </section>
      )}

      {loading ? (
        <CircularProgress />
      ) : (
        <div className="table-container">
          <div className="results-summary">
            Showing {filteredGames.length} of {gamesList.length} games
          </div>
          <GamesTableComponent
            games={filteredGames}
            onGameClick={handleGameClick}
          />
        </div>
      )}

      <GameDetailsDrawer
        game={selectedGame}
        matchedGameData={matchedGameData}
        open={drawerOpen}
        onClose={handleCloseDrawer}
      />
    </div>
  );
};

export default GamesPage;